/**
 * mediaService.js
 *
 * All media/file-related API calls.
 * Note: File uploads use FormData — apiClient handles multipart automatically.
 *
 * Usage:
 *   import { mediaService } from 'services/api';
 *   const data = await mediaService.getMedia(userId);
 */

import apiClient from '../apiClient';

export const mediaService = {
  /** GET /media/:userId — all media files for a user */
  getMedia: (userId) =>
    apiClient.get(`/media/${userId}`).then((res) => res.data),

  /** GET /media/get-file/:id — get a specific media file */
  getFile: (id) =>
    apiClient.get(`/media/get-file/${id}`).then((res) => res.data),

  /**
   * POST /upload-media — upload media to server
   * @param {FormData} formData
   */
  uploadToServer: (formData) =>
    apiClient.post('/upload-media', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then((res) => res.data),

  /**
   * GET /media-restore/:id/:metaId — restore expired media with new meta ID
   */
  restoreMedia: (id, metaId) =>
    apiClient.get(`/media-restore/${id}/${metaId}`).then((res) => res.data),

  /** DELETE /media/permanent-delete/:id */
  permanentDelete: (id) =>
    apiClient.delete(`/media/permanent-delete/${id}`).then((res) => res.data),

  /** DELETE /delete-media/:id — soft delete */
  softDelete: (id) =>
    apiClient.delete(`/delete-media/${id}`).then((res) => res.data),

  /** GET /user/:userId/storage — storage usage stats */
  getStorageStats: (userId) =>
    apiClient.get(`/user/${userId}/storage`).then((res) => res.data),
};
